import { Usuarios, RetAPI, NewUsuarios, error99 } from '../../Utils/Types'
import { Api } from '../../Utils/api'

export const ProfileService = {

    GetAttributes: async (): Promise<RetAPI> => {
        const resp = await Api('auth/getUser', 'get')
        let usua: Usuarios = {
            id: 0,
            nome: '',
            email: '',
            password: '',
            ativo: false,
            id_empresa: 0,
            description: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: usua
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                usua = {
                    id: resp.data.user.id,
                    nome: resp.data.user.nome,
                    email: resp.data.user.email,
                    password: resp.data.user.password,
                    ativo: resp.data.user.ativo,
                    id_empresa: resp.data.user.id_empresa,
                    celular: resp.data.user.celular,
                    token: resp.data.user.token,
                    description:resp.data.user.nome
                }

            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: usua
            }
        }

        return {
            error: false,
            data: usua
        }

    },

    Save: async (newusuario: NewUsuarios): Promise<RetAPI> => {

        const resp = await Api('auth/update', 'post',
            {
                name: newusuario.name,
                old_password: newusuario.oldPassword,
                new_password: newusuario.newPassword,
                repeat_password: newusuario.repeatPassword
            }
        )

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                }
            }

            return {
                error: false,
                msg: 'Dados alterados com sucesso',
                id: resp.data.id
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    }

}